import { isValidLocale } from 'utils/Locales';
import { useQuery } from '@tanstack/react-query';
import { ContentType, Reseller } from 'api/contentful/contentTypes.cloverdotcom';
import { fetchEntries } from 'api/contentful/fetchEntries';
import { useTranslation } from 'react-i18next';
import { get, isEntry } from 'utils/EntryUtil';
import { Entry } from 'contentful';
import { getDefaultPartnerKey } from 'hooks/Reseller/util';

export const RESELLER_NOT_FOUND_ERROR_MSG = 'Reseller not found in Contentful.';

export const fetchContentfulReseller = async (locale: string, trackingHost: string) => {
  const resellers = await fetchEntries<Reseller>(locale, {
    contentType: ContentType.RESELLER,
    filters: { fields: { referrerDomains: trackingHost } },
    include: 2,
    limit: 1,
  });

  const [item] = get(resellers, 'items', []) as Entry<Reseller>[];

  if (!item || !isEntry(item)) throw new Error(RESELLER_NOT_FOUND_ERROR_MSG);

  return item;
};

export const useContentfulResellerQuery = (trackingHost = getDefaultPartnerKey()) => {
  const {
    i18n: { language: locale },
  } = useTranslation();

  return useQuery(
    ['contentfulReseller', locale, trackingHost],
    async () => fetchContentfulReseller(locale, trackingHost),
    {
      enabled: isValidLocale(locale),
    },
  );
};
